'use strict';

const $ = require('jquery');

class ProductViewSwitch {

    constructor() {

        let $switch = $('[data-view-switch]');

        $switch.on('click', 'a', (event) => {

            event.preventDefault();

            let $this = $(event.currentTarget);
            let type = $this.attr('href').replace('#', '');

            $this.closest('[data-ajax-area]').removeClass('type-grid type-list').addClass(`type-${type}`);

            $switch.find('a').removeClass('active');
            $this.addClass('active');
        });

    }

}

module.exports = ProductViewSwitch;
